import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import MessagesFilters from '../components/message-filters/MessagesFilters';
import Messages from '../components/messages/Messages';
import { changeTableSettings, clearLocalMessages } from '../../../../redux/activ8/activ8MessagesReducer';

function GeneratedTab({ bindNextAction }) {
  const dispatch = useDispatch();

  const content = useSelector((state) => state.activ8Messages.messagesContent);
  const isLoading = useSelector((state) => state.activ8Messages.isMessagesLoading);
  const tableSettings = useSelector((state) => state.activ8Messages.tableSettings);

  const handleClearAll = () => {
    dispatch(clearLocalMessages());
  };

  const handleChangeSearch = (newSearch) => {
    dispatch(changeTableSettings({ searchQuery: newSearch, page: 0 }));
  };

  const filteredContent = useMemo(() => {
    return content.filter((message) => message.message.toLowerCase().includes(tableSettings.searchQuery.toLowerCase()));
  }, [content, tableSettings.searchQuery]);

  return (
    <>
      <MessagesFilters
        onClearAll={handleClearAll}
        query={tableSettings.searchQuery}
        onChangeSearch={handleChangeSearch}
      />
      <Messages
        bindNextAction={bindNextAction}
        content={filteredContent}
        isLoading={isLoading}
        isShowSaveButton={true}
      />
    </>
  );
}

export default GeneratedTab;
